import React, { useState } from "react";

import ReusableForm from "../../../../../common/ReusableForm";
import { Typography } from "@mui/material";
import { editInstituteProfessorColums } from "../../../../../../utils/tableConfig";

const EditProfessor = ({
  handleSubmit,
  handleCloseModal,
  handleInputChange,
  data,
  isDisabled,
  formError,
  isLoading,
}) => {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Edit User
      </Typography>
      <ReusableForm
        fields={editInstituteProfessorColums}
        handleChange={handleInputChange}
        handleSubmit={handleSubmit}
        errors={formError}
        formData={data}
        handleCloseModal={handleCloseModal}
        isDisabled={isDisabled}
        isApiLoading={isLoading?.isLoading}
      />
    </>
  );
};

export default EditProfessor;
